export const ALGOLIA = {
  localhost: {
    // Amrita Nutrition Development
    YourApplicationID: "VNZFMWYZZ4",
    YourSearchOnlyAPIKey: "f8e07f5ea1e79125a41d1a239b483b42",
    indexName: "shopify_uk_test_products",
  },
  "amrita-nutrition-development.myshopify.com": {
    // Amrita Nutrition Development
    YourApplicationID: "VNZFMWYZZ4",
    YourSearchOnlyAPIKey: "f8e07f5ea1e79125a41d1a239b483b42",
    indexName: "shopify_uk_test_products",
  },
  "amrita-uk-test.myshopify.com": {
    // Amrita Nutrition Development
    YourApplicationID: "VNZFMWYZZ4",
    YourSearchOnlyAPIKey: "f8e07f5ea1e79125a41d1a239b483b42",
    indexName: "shopify_uk_test_products",
    cats: "https://func-amritaalgoliacats-qa.azurewebsites.net/api",
  },
  "amrita-nutrition-b2b.myshopify.com": {
    // Amrita Nutrition UK Live
    YourApplicationID: "UWSGO0DAPL",
    YourSearchOnlyAPIKey: "ddcb7d546fbd24b555f171c39f0f986c",
    indexName: "shopify_an_uk_live_products",
    cats: "https://func-amritaalgoliacats-prod.azurewebsites.net/api",
  },
};
